import { S25Icons } from "../modules/s25-icon/s25.icon.const";
import type { Event } from "./Event";
import type { Location } from "./Location";
import type { Organization } from "./Organization";
import type { Resource } from "./Resource";
import type { S25ItemI } from "./S25ItemI";
import type { Task } from "./Task";
import type { Contact } from "./Contact";
import type { Requirement } from "./Requirement";
import type { Report } from "./Report";
import type { ConflictBlock } from "./ConflictBlock";
import type { RateSchedule } from "./RateSchedule";
import { S25Const } from "../util/s25-const";

export namespace Item {
    export type Subject = Data["subject"];
    // TODO: consider renaming Id(s) to TypeId(s)?
    export type Id = Data["id"];

    export enum Ids {
        Event = 1,
        Organization = 2,
        Contact = 3,
        Location = 4,
        RateSchedule = 5,
        Resource = 6,
        Requirement = 7,
        Report = 9,
        Task = 10,
        ConflictBlock = 999,
        EventType = 19, // from dbo.object_type table
    }

    export const AvailabilityItemTypeId = 19991;
    export type AvailabilityItemTypeId = typeof AvailabilityItemTypeId;

    export const TypeIcons: { [key in Ids | AvailabilityItemTypeId]?: S25Icons.Name } = {
        [Ids.Event]: S25Icons.names.event,
        [AvailabilityItemTypeId]: S25Icons.names.event,
        [Ids.Organization]: S25Icons.names.organization,
        [Ids.Contact]: S25Icons.names.contact,
        [Ids.Location]: S25Icons.names.location,
        [Ids.Resource]: S25Icons.names.resource,
        [Ids.Report]: S25Icons.names.reports,
        [Ids.Task]: S25Icons.names.task,
    };

    export type Data =
        | Event.Data
        | Organization.Data
        | Contact.ItemData
        | Location.Data
        | Resource.Data
        | Requirement.Data
        | Report.Data
        | Task.Data
        | ConflictBlock.Data
        | RateSchedule.Data;

    export type Event = Item<Item.Ids.Event> & Pick<S25ItemI, "itemDesc">;
    export type Organization = Item<Item.Ids.Organization> & Pick<S25ItemI, "itemDesc">;
    export type Contact = Item<Item.Ids.Contact>;
    export type Location = Item<Item.Ids.Location> & Pick<S25ItemI, "itemDesc">;
    export type Resource = Item<Item.Ids.Resource>;

    export function profileName(profileNameString?: string): string | null | undefined {
        return profileNameString && (profileNameString?.toLowerCase().indexOf("rsrv_") > -1 ? null : profileNameString);
    }

    export function isPrivate(itemName: string) {
        return String(itemName).toLowerCase() === S25Const.private.toLowerCase();
    }
}

export type Item<T = Item.Ids> = Pick<S25ItemI, "itemName" | "favorite" | "itemDesc"> & {
    itemId: number;
    itemTypeId: T;
};

export type HasItemType<T extends Item.Id = Item.Id> = { itemTypeId: T };
